// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"30":"c28899c0f168f6aa","711":"db81a3f0efb8b1da"}[chunkId] + ".js";
};